import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/player-combination-stacking/actions';
import {StackItem} from '../../../stack-item';
import SelectPlayers from '../../molecules/select-players';
import PlayersQuantity from '../../atoms/players-quantity';
import LineupsQuantity from '../../atoms/lineups-quantity';
import UseSecondaryGroup from '../../atoms/use-secondary-group';
import Validator from '../../../validators/validator';
import InputRadio from 'components/atoms/inputs/input-radio';
import {showPopup} from 'helpers/modal';
import {interpret} from 'dictionary';
import EnableSwitch from 'components/organisms/player-combination-stacking/enable-switch';

class Settings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            minPlayersInPrimaryGroup: 0,
            maxPlayersInPrimaryGroup: 4,
            playerIdsInPrimaryGroup: [],
            minPlayersInSecondaryGroup: 0,
            maxPlayersInSecondaryGroup: 4,
            playerIdsInSecondaryGroup: [],
            useSecondaryGroup: 0,
            useStackInAllLineups: 0,
            minLineups: 1,
        };
    }

    onAddStackItem() {
        const stackItem = new StackItem({...this.state});
        try {
            this.addStackItem(stackItem);
        } catch (e) {
            this.props.dispatch(showPopup(e.message));
        }
    }

    addStackItem(stackItem) {
        this.assertSettingsValid(stackItem);
        this.props.dispatch(Action.do('addItemToPlayerCombinationStacking', stackItem));
    }

    assertSettingsValid(stackItem) {
        const {sportConfig} = this.props;
        const validator = new Validator();
        validator.setDependencies({stackItem, sportConfig});
        if (!validator.validate()) {
            throw new Error(validator.getFirstError());
        }
    }

    onBlurLineupQuantity(value) {
        this.setState({minLineups: Number(value)});
    }

    onSelectPlayersInPrimaryGroup(playerIdsInPrimaryGroup) {
        this.setState({playerIdsInPrimaryGroup});
    }

    onSelectPlayersInSecondaryGroup(playerIdsInSecondaryGroup) {
        this.setState({playerIdsInSecondaryGroup});
    }

    onChangeMinPlayersInPrimaryGroup(minPlayersInPrimaryGroup) {
        this.setState({minPlayersInPrimaryGroup});
    }

    onChangeMaxPlayersInPrimaryGroup(maxPlayersInPrimaryGroup) {
        this.setState({maxPlayersInPrimaryGroup});
    }

    onChangeMinPlayersInSecondaryGroup(minPlayersInSecondaryGroup) {
        this.setState({minPlayersInSecondaryGroup});
    }

    onChangeMaxPlayersInSecondaryGroup(maxPlayersInSecondaryGroup) {
        this.setState({maxPlayersInSecondaryGroup});
    }

    onChangeUseStackInAllLineups(value) {
        this.setState({useStackInAllLineups: Number(value)});
    }

    onChangeUseSecondaryGroup(value) {
        this.setState({useSecondaryGroup: Number(value)});
    }

    render() {
        return (
            <div className="white-box">
                <div className="advanced-filter-heading">
                    <h3>{interpret('player combination rules')}</h3>
                    <EnableSwitch />
                </div>
                <div className="gray-holder gap-y">
                    <div className="form-inline">
                        <div className="form-text">Stack between</div>

                        <PlayersQuantity
                            value={this.state.minPlayersInPrimaryGroup}
                            range={[0, 1, 2, 3, 4]}
                            onChange={::this.onChangeMinPlayersInPrimaryGroup}
                        />

                        <div className="form-text">and</div>

                        <PlayersQuantity
                            value={this.state.maxPlayersInPrimaryGroup}
                            range={[1, 2, 3, 4]}
                            onChange={::this.onChangeMaxPlayersInPrimaryGroup}
                        />
                        <div className="form-text">of</div>

                        <SelectPlayers onSelect={::this.onSelectPlayersInPrimaryGroup} />

                        <UseSecondaryGroup
                            value={this.state.useSecondaryGroup}
                            onChange={::this.onChangeUseSecondaryGroup}
                        />

                        {this.state.useSecondaryGroup ? (
                            <>
                                <div className="form-text">between</div>

                                <PlayersQuantity
                                    value={this.state.minPlayersInSecondaryGroup}
                                    range={[0, 1, 2, 3, 4]}
                                    onChange={::this.onChangeMinPlayersInSecondaryGroup}
                                />

                                <div className="form-text">and</div>

                                <PlayersQuantity
                                    value={this.state.maxPlayersInSecondaryGroup}
                                    range={[1, 2, 3, 4]}
                                    onChange={::this.onChangeMaxPlayersInSecondaryGroup}
                                />

                                <div className="form-text">of</div>

                                <SelectPlayers onSelect={::this.onSelectPlayersInSecondaryGroup} />

                                <div className="form-text">in</div>
                            </>
                        ) : null}

                        <label className="radio-inline">
                            <InputRadio
                                value={0}
                                checked={!this.state.useStackInAllLineups}
                                onChange={::this.onChangeUseStackInAllLineups}
                            />
                            min
                        </label>

                        <LineupsQuantity value={this.state.minLineups} onBlur={::this.onBlurLineupQuantity} />
                        <div className="form-sub-text">lineups</div>

                        <label className="radio-inline">
                            <InputRadio
                                value={1}
                                checked={this.state.useStackInAllLineups}
                                onChange={::this.onChangeUseStackInAllLineups}
                            />
                            All lineups
                        </label>

                        <div className="advanced-filter-actions">
                            <button type="submit" onClick={::this.onAddStackItem} className="btn">
                                Add Rule
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {playerCombinationStacking, sportConfig} = state;

    return {
        stacking: playerCombinationStacking,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(Settings);
